// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

/* Global styles */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  background-color: white;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 3rem;
  text-align: center;
  position: relative;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s ease-out 0.2s forwards;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  border-radius: 2px;
}

.btn {
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 5px;
  transition: all 0.3s ease;
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn:hover::before {
  width: 300px;
  height: 300px;
}

.btn-primary {
  background-color: #ffbb00;
  color: #000;
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
  font-weight: 700;
}

.btn-primary:hover {
  background-color: #cc9900;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);
}

.btn-large {
  font-size: 1.2rem;
  padding: 16px 40px;
  font-weight: 700;
}

.btn-secondary {
  background-color: transparent;
  color: #ffbb00;
  border: 2px solid #ffbb00;
}

.btn-secondary:hover {
  background-color: #ffbb00;
  color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,6CAA6C;AAC/C","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n/* Global styles */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.section {\n  padding: 80px 0;\n  position: relative;\n  overflow: hidden;\n  background-color: white;\n}\n\n.section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 3rem;\n  text-align: center;\n  position: relative;\n  opacity: 0;\n  transform: translateY(20px);\n  animation: fadeInUp 0.8s ease-out 0.2s forwards;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 4px;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  border-radius: 2px;\n}\n\n.btn {\n  padding: 12px 30px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.btn:hover::before {\n  width: 300px;\n  height: 300px;\n}\n\n.btn-primary {\n  background-color: #ffbb00;\n  color: #000;\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n  font-weight: 700;\n}\n\n.btn-primary:hover {\n  background-color: #cc9900;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);\n}\n\n.btn-large {\n  font-size: 1.2rem;\n  padding: 16px 40px;\n  font-weight: 700;\n}\n\n.btn-secondary {\n  background-color: transparent;\n  color: #ffbb00;\n  border: 2px solid #ffbb00;\n}\n\n.btn-secondary:hover {\n  background-color: #ffbb00;\n  color: #000;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
